"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeAttackBonus = exports.isOvercomeBy = exports.isGeneratedBy = exports.typeInteractions = void 0;
// overcome / generated are Tuxemon language
exports.typeInteractions = {
    ["earth"]: {
        generatedBy: "fire",
        overcomeBy: "wood",
    },
    ["metal"]: {
        generatedBy: "earth",
        overcomeBy: "fire",
    },
    ["water"]: {
        generatedBy: "metal",
        overcomeBy: "earth",
    },
    ["wood"]: {
        generatedBy: "water",
        overcomeBy: "metal",
    },
    ["fire"]: {
        generatedBy: "wood",
        overcomeBy: "water",
    },
};
const isGeneratedBy = (defender, attacker) => { var _a; return ((_a = exports.typeInteractions[defender]) === null || _a === void 0 ? void 0 : _a.generatedBy) === attacker; };
exports.isGeneratedBy = isGeneratedBy;
const isOvercomeBy = (defender, attacker) => { var _a; return ((_a = exports.typeInteractions[defender]) === null || _a === void 0 ? void 0 : _a.overcomeBy) === attacker; };
exports.isOvercomeBy = isOvercomeBy;
const STRONG_ATTACK_MODIFIER = 1.7;
const WEAK_ATTACK_MODIFIER = 0.3;
const getTypeAttackBonus = (attackerTraits, defenderTraits) => {
    // are any of the defenders traits overcome by the attackers traits?
    const defenderOvercome = defenderTraits.some((defenceType) => attackerTraits.some((attackType) => (0, exports.isOvercomeBy)(defenceType, attackType)));
    if (defenderOvercome) {
        return STRONG_ATTACK_MODIFIER;
    }
    // are any of the attackers traits overcome by the defenders traits?
    const attackerOvercome = attackerTraits.some((attackType) => defenderTraits.some((defenceType) => (0, exports.isOvercomeBy)(defenceType, attackType)));
    if (attackerOvercome) {
        return WEAK_ATTACK_MODIFIER;
    }
    return 1;
};
exports.getTypeAttackBonus = getTypeAttackBonus;
